import { CustomAlertType } from 'builder/modules/jobSearch/types'
import { SearchSuggestionType } from '../AutoSuggestField/types'
import { Filters } from '../types'
import { JobLocationType } from '../JobSearchResult/types'

interface Params {
  targetRole: string | undefined
  filters: Filters
  selectedLocation: SearchSuggestionType | undefined
}
export const generateEditCustomAlert = ({
  targetRole,
  filters,
  selectedLocation,
}: Params): CustomAlertType => {
  let locationText: string | undefined
  let locationId: number | undefined

  if (selectedLocation?.locationType === 'near_me') {
    locationText = selectedLocation.text
  }

  if (
    selectedLocation?.locationType === 'string_location' ||
    selectedLocation?.locationType === 'location_id'
  ) {
    locationText = selectedLocation?.formatted
  }

  if (typeof selectedLocation?.value === 'string' || typeof selectedLocation?.value === 'number') {
    locationId = parseInt(selectedLocation.value)
  }

  return {
    active: true,
    targetRole,
    onlyRemoteJobs:
      filters.jobLocationType === JobLocationType.REMOTE ||
      selectedLocation?.locationType === 'remote',
    location: locationText,
    locationId,
  }
}
